import React from "react";
import Skeleton from "react-loading-skeleton";

interface ISkeletonContainerProps {
	cardCount?: number;
	loadingText?: string;
}

export const SkeletonContainer: React.FC<ISkeletonContainerProps> = ({
	cardCount = 4,
	loadingText = "Loading data...",
}) => {
	const isSmallScreen =
		typeof window !== "undefined" && window.innerWidth < 768;

	return (
		<div className="flex flex-col justify-center items-center min-h-[200px] w-full gap-4">
			<div className="flex gap-4 flex-wrap md:flex-nowrap w-full">
				{isSmallScreen ? (
					<div style={{ width: "100%" }}>
						<Skeleton width="100%" height={179} className="rounded" />
					</div>
				) : (
					Array.from({ length: cardCount }).map((_, index) => (
						<div key={index} style={{ flex: 1, minWidth: 0 }}>
							<Skeleton width="100%" height={179} className="rounded" />
						</div>
					))
				)}
			</div>
			<span className="text-sm text-gray-500 mt-2">{loadingText}</span>
		</div>
	);
};

export default SkeletonContainer;
